import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=37d27bfc&scoped=true&"
import script from "./Wait.vue?vue&type=script&lang=js&"
export * from "./Wait.vue?vue&type=script&lang=js&"
import style0 from "./Wait.vue?vue&type=style&index=0&id=37d27bfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d27bfc",
  null
  
)

export default component.exports